import { useEffect, useState } from "react";
import {
  EMPTY_ACTIVITY_STATS,
  EMPTY_GAMES_PLAYED_STATS,
  fetchDckslapActivitySnapshot,
  getCachedDckslapActivitySnapshot,
} from "../services/activityStats";

const EMPTY_DATASET = {
  transfers: [],
  mints: [],
};

export const useDckslapActivityStats = () => {
  const initialSnapshot = getCachedDckslapActivitySnapshot();
  const [snapshot, setSnapshot] = useState(initialSnapshot);
  const [isLoading, setIsLoading] = useState(() => !initialSnapshot);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;
    const applyCachedSnapshotProgress = () => {
      if (!isMounted) return;

      const cachedSnapshot = getCachedDckslapActivitySnapshot();
      if (!cachedSnapshot) {
        return;
      }

      setSnapshot((currentSnapshot) => {
        if (
          currentSnapshot?.fetchedAt === cachedSnapshot.fetchedAt &&
          currentSnapshot?.stats?.ociswapTradeCount ===
            cachedSnapshot.stats?.ociswapTradeCount &&
          currentSnapshot?.stats?.caviarnineTradeCount ===
            cachedSnapshot.stats?.caviarnineTradeCount &&
          currentSnapshot?.stats?.defiplazaTradeCount ===
            cachedSnapshot.stats?.defiplazaTradeCount &&
          currentSnapshot?.stats?.reddicksDexTradeCount ===
            cachedSnapshot.stats?.reddicksDexTradeCount
        ) {
          return currentSnapshot;
        }

        return cachedSnapshot;
      });
    };

    const progressInterval = window.setInterval(applyCachedSnapshotProgress, 5000);

    const refreshSnapshot = async () => {
      try {
        const freshSnapshot = await fetchDckslapActivitySnapshot();
        if (!isMounted) return;

        setSnapshot(freshSnapshot);
        setError(null);
      } catch (fetchError) {
        if (!isMounted) return;
        applyCachedSnapshotProgress();
        setError(fetchError);
      } finally {
        window.clearInterval(progressInterval);
        if (isMounted) {
          applyCachedSnapshotProgress();
          setIsLoading(false);
        }
      }
    };

    applyCachedSnapshotProgress();
    refreshSnapshot();

    return () => {
      isMounted = false;
      window.clearInterval(progressInterval);
    };
  }, []);

  return {
    dckslapData: snapshot?.dckslapData || EMPTY_DATASET,
    gbofData: snapshot?.gbofData || EMPTY_DATASET,
    totalPlayersCount:
      snapshot?.totalPlayersCount ||
      snapshot?.stats?.totalPlayersCount ||
      snapshot?.stats?.totalParticipants ||
      0,
    globalDepositCount: snapshot?.globalDepositCount || 0,
    gamesPlayedStats: snapshot?.gamesPlayedStats || EMPTY_GAMES_PLAYED_STATS,
    stats: snapshot?.stats || EMPTY_ACTIVITY_STATS,
    fetchedAt: snapshot?.fetchedAt || null,
    isLoading,
    error,
    hasCachedData: Boolean(snapshot),
    isFresh: Boolean(snapshot?.isFresh),
  };
};

export default useDckslapActivityStats;
